define('modules/base/views/base.metric.view',[
    'client',
    'jquery',
    'jqueryUi',
    'underscore',
    'backbone',
    "marionette",
    'modules/base/views/base.view',
    'text!modules/base/templates/base.metric.template.html'
], function(Prospector,$, jqueryUi, _,Backbone,
            Marionette,
            BaseView,
            Template) {
    var BaseMetricView = BaseView.extend({
        template: _.template(Template),
        className: 'baseMetricView',//base class without Bootstrap
        events:function() {
            var base = {
            };
            var click = {
            };
            $.extend(base,click);
            return base;
        },
        initialize: function(options){ //constructor
            this.title = options.title;
            this.model = new Backbone.Model(options.model);
        },
        getRemaining:function(type){
            if(this.model.get('limit') == 0){
                return "Unlimited";
            } else {
                var res = this.model.get('limit') - this.model.get('used');
                if(res < 0){
                    res = 0;
                }
                return res;
            }
        },
        getLimit:function(){
            if(this.model.get('limit') == 0){
                return "unlimited";
            } else {
                return this.model.get('limit');
            }
        },
        getUsed:function(){
            if(this.model.get("used") > this.getLimit()){
                return this.getLimit();
            } else {
                return this.model.get("used");
            }
        },
        getPercentUsed:function(){
            if(this.model.get('limit') == 0){
                return 0;
            } else {
                var res = Math.ceil(100*this.model.get('used')/ this.model.get('limit'));
                if(res > 100){
                    res = 100;
                }
                return res;
            }
        },

        onRender:function(){
            this.$('.quotaTitle').html(this.title);
            this.$('.quotaRemaining').html(this.getRemaining() + ' remaining');
            this.$('.quotaUsed').html(this.getUsed());
            this.$('.quotaTotal').html('of ' + this.getLimit() + ' used');

            window.setTimeout($.proxy(function(){
                this.$('.percentage').css('width',  this.getPercentUsed() + '%');
            }, this), 500);
        }
    });
    return BaseMetricView;
});
